import * as THREE from 'three'
import { getLineMaterial } from '../utils/helper_functions'

export const drawTableHalfCircle = (
  centerPos,
  faceTo,
  color,
  radius,
  materials,
  sceneMeshes
) => {
  const sign = faceTo === 'left' ? 1 : -1

  const geometry = new THREE.CircleGeometry(
    radius,
    32,
    (sign * Math.PI) / 2,
    Math.PI
  )

  const obj = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({ color }))

  obj.position.set(-centerPos.x - 0.2 * sign, 0, 0)

  const { array: gArray } = geometry?.attributes?.position
  const geometryArray = []
  geometryArray.push(
    new THREE.Vector3(gArray[3], gArray[4], 0),
    new THREE.Vector3(gArray[6], gArray[7], 0)
  )
  const separationLineGeometry = new THREE.BufferGeometry().setFromPoints(
    geometryArray
  )

  const separationLineBasicMaterial = getLineMaterial(
    { color: '#FFFFFF' },
    materials
  )
  const borderLineBasicMaterial = getLineMaterial({ color }, materials)
  const separationLine = new THREE.Line(
    separationLineGeometry,
    separationLineBasicMaterial
  )

  const edges = new THREE.RingGeometry(
    radius,
    radius,
    32,
    1,
    (sign * Math.PI) / 2,
    Math.PI
  )

  const border = new THREE.Line(edges, borderLineBasicMaterial)
  border.position.set(-centerPos.x - 0.1 * sign, 0, 0)

  obj.renderOrder = 100
  border.renderOrder = 100
  separationLine.renderOrder = 101

  const triangle = new THREE.Group()
  triangle.add(obj)
  triangle.add(separationLine)
  triangle.add(border)

  triangle.obj = obj
  triangle.separationLine = separationLine
  triangle.border = border
  sceneMeshes.push(triangle)

  return [triangle]
}
